import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  AfWhitelist,
  AfwhitelistMenuActionsType,
} from 'data/afWhitelist/afWhitelist.types'
import './afwhitelist-action-menu.scss';

type Props = {
  selectedItem?: AfWhitelist;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onDelete: ()=> void;
}

const MediaGatewayMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="AfWhitelistMenu" className="afwhitelist-action-menu">
      {hasPrivilegesToCreate && (
      <Button
        className="afwhitelist-action-menu-button"
        data-testid={`${AfwhitelistMenuActionsType.Edit}-button`}
        text={t('common.grid.action.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="afwhitelist-action-menu-button"
        data-testid={`${AfwhitelistMenuActionsType.Delete}-button`}
        text={t('common.grid.action.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('afWhitelist.deletePopup.title')}
        displayMessage={
          t('afWhitelist.deletePopup.message', { name: selectedItem.AFID })
        }
        actionText={t('common.button.confirmDelete')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default MediaGatewayMenu;
